import sumBy from "lodash/sumBy";
import { mapMaterialsWithUnits } from "./mapMaterialsWithUnits";
import { InvoiceTransaction, RawInvoiceTransaction } from "../types";

export const getMappedTransactions = (
  transactions: RawInvoiceTransaction[]
): InvoiceTransaction[] => {
  return transactions.map(({ materials, ...rest }: RawInvoiceTransaction) => ({
    materials: mapMaterialsWithUnits(materials),
    weight: sumBy(materials, "weight"),
    sourceName: materials[0]?.sourceName,
    destinationName: materials[0]?.sourceName,
    ...rest,
  }));
};

export default getMappedTransactions;
